import React from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Collapse,
  Button,
} from "reactstrap"

const Faqs = () => {
  const faqs = [
    {
      question: "What is React?",
      answer: "React is a JavaScript library for building user interfaces.",
    },
    {
      question: "What is a component in React?",
      answer:
        "A component in React is a reusable piece of UI that can have its own logic and state.",
    },
    {
      question: "What is the difference between props and state?",
      answer:
        "Props are used to pass data from parent to child components, while state is used to manage local data within a component.",
    },
    {
      question: "What is a JavaScript Promise?",
      answer:
        "A JavaScript Promise is an object that represents the eventual completion (or failure) of an asynchronous operation and its resulting value.",
    },
    {
      question: "What are closures in JavaScript?",
      answer:
        "Closures are functions that remember the environment in which they were created, even after the environment has closed.",
    },
  ]

  const [openIndex, setOpenIndex] = React.useState(null)

  const toggle = index => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <Container style={{ marginTop: "40px" }}>
      <Row>
        <Col>
          <h1 className="text-center mb-4">Programming FAQs</h1>
          <p className="text-center mb-5">
            Find answers to some of the most common questions about programming.
          </p>
        </Col>
      </Row>
      <Row>
        {faqs.map((faq, index) => (
          <Col md={12} key={index} className="mb-3">
            <Card>
              <CardBody>
                <h5
                  className="d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => toggle(index)}
                >
                  {faq.question}
                  <i
                    className={`mdi mdi-chevron-${
                      openIndex === index ? "up" : "down"
                    }`}
                  ></i>
                </h5>
                <Collapse isOpen={openIndex === index}>
                  <div style={styles.collapseContent}>{faq.answer}</div>
                </Collapse>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

const styles = {
  collapseContent: {
    paddingTop: "10px", // Smooth transition padding
    paddingBottom: "10px",
    transition: "padding 0.3s ease", // Smooth padding animation
  },
}

export default Faqs
